import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { replaceUnderscoresWithSpaces } from "utils";
import { fetchCommentName } from "services/dropdown";

const CommentNameDropdown = ({ investigationId, setFilterValue, value }) => {
  const key = "comment_name";
  const { data, isLoading, error } = useQuery(
    ["comment-name-dropdown", investigationId],
    () => fetchCommentName({ investigation_id: investigationId }),
    {
      keepPreviousData: false,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      enabled: !!investigationId,
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading comment names</div>;

  const options =
    data?.data?.map((item) => ({
      value: item.id,
      label: item.comment_name,
      comments: item?.comments,
    })) || [];

  let selectedOption = null;

  if (value !== undefined && value !== null) {
    if (typeof value === "object" && value.comment_id) {
      selectedOption =
        options.find((option) => option.value === value.comment_id) || null;
    } else if (typeof value === "number" || typeof value === "string") {
      selectedOption = options.find((option) => option.value === value) || null;
    }
  }

  return (
    <Select
      options={options}
      value={selectedOption}
      isClearable
      placeholder={`Select ${replaceUnderscoresWithSpaces(key)}`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      onChange={(selectedOption) => {
        if (selectedOption === null) {
          setFilterValue(null);
        } else {
          const value = selectedOption.value;
          const label = selectedOption.label;
          const comment = selectedOption.comments;
          setFilterValue({
            comment_id: value,
            comment_name: label,
            comments: comment,
          });
        }
      }}
      className={`react-select-container is-invalid`}
    />
  );
};

export default CommentNameDropdown;
